import React from 'react';
import { OnlinebookingFeatureAppDependencies } from './';

export const FeatureServicesContext = React.createContext<OnlinebookingFeatureAppDependencies | undefined>(undefined);

export function useFeatureServices(): OnlinebookingFeatureAppDependencies {
  const featureServices = React.useContext(FeatureServicesContext);

  if (!featureServices) {
    throw new Error('No featureServices context value was provided.');
  }

  return featureServices;
}
